import ToolToggleBlock from './ToolToggleBlock';

class ToolToggleCode extends ToolToggleBlock {
  static toolName = 'Code block';
  static iconClass = 'fa-regular fa-rectangle-code';
  static blockType = 'code';
}

export default ToolToggleCode;
